import React from 'react';

import { t } from '../../services/i18nService';
import timeService from '../../services/TimeService';
import utilService from '../../services/UtilService';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';

import styles from './options.scss';

class OptionsAddExtraTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = { done: false };
    }

    actionHandler = () => {
        const minutes = utilService.getIntOr(this.inputElement.value, 0);
        timeService.addTimeInMinutes(minutes);
        this.setState({ done: true, minutes });
    };

    render() {
        const mainButtonText = t('options.addExtraTimeAddButton');

        const contentChildren = (
            <p className={styles.textInput}>
                <label htmlFor="optionsExtraTimeInput">
                    {t('options.addExtraTimeInputLabel')}
                </label>
                <input
                    defaultValue="30"
                    id="optionsExtraTimeInput"
                    ref={(element) => { this.inputElement = element; }}
                    type="number"
                />
            </p>
        );

        return (
            <div>
                <OptionsTopBar title={t('options.addExtraTimeTitle')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    {
                        this.state.done ?
                            <div className={styles.optionCompleteText}>
                                {t('options.addExtraTimeAddedConfirmation', { minutes: this.state.minutes })}
                            </div>
                            :
                            <Confirmation
                                actionHandler={this.actionHandler}
                                contentChildren={contentChildren}
                                mainButtonText={mainButtonText}
                                requireInvigilatorPassword
                            />
                    }
                </div>
            </div>
        );
    }
}

export default OptionsAddExtraTime;
